/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import TableRow from "../../../Helpers/Table/TableRow";
import { filtrationcontext } from "../../../../context/Filtercontext";
import { useNavigate } from "react-router-dom";
import Empty from "../../../Helpers/Empty/Empty";
import trans from "../../../../utils";

export default function ReportsTypesTableBody({ data }) {
	const { searchQuery } = useContext(filtrationcontext);
	let navigate = useNavigate();
	const filteredData = data.filter((i) => {
		const searchValue = searchQuery.toLowerCase();
		return (i.name || "").toLowerCase().includes(searchValue);
	});
	if (filteredData.length === 0)
		return (
			<Empty
				title={trans("No Reports Found")}
				subtitle={trans("Create new report now!")}
			/>
		);
	const reportsheet = (name, reportType) => {
		navigate(`./${reportType}/${name}`);
	};
	return (
		<>
			{filteredData.map((i, indx) => (
				<div
					key={indx}
					className="table-row"
					onClick={() => reportsheet(i.shortname, i.reportType)}
				>
					<TableRow value={i.name} style="ps-0" />
					<TableRow value={i.description} />
					<TableRow value={trans(i.reportType)} valuestyle="reporttype" />
				</div>
			))}
		</>
	);
}
